<ngx-monaco-editor
  class="editor"
  [options]="editorOptions"
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"></ngx-monaco-editor>
